
import $ from 'jquery';
import _ from 'lodash';
import eventBus from 'EventBus';
import { Model } from 'backbone';
import RestService from 'RestService';
import xjService from 'xml/XJService';
import zLib from 'util/ZLib';
import notificationService from 'NotificationService';
import sequenceService from 'SequenceService';

import constants from 'Constants.js';
import SelectItemModalView from 'common-views/SelectItemModalView';
import SimpleConfirmModalView from 'common-views/SimpleConfirmModalView';
import TestActionModalView from 'common-views/TestActionModalView';
import FormLoadService from 'FormLoadService';
import AlertDialogView from 'common-views/AlertDialogView.js';
import Immutable from 'immutable';
import util from 'util/Util';
import listService from 'ListService.js';

import ConnectionDashboardController from 'ConnectionDashboardController';
import undoService from 'UndoService.js'
import textConstants from 'TextConstants';
import Spinner from 'spin/spin';

class ActionService {

    constructor(opts) {
        this.model = opts.model;
    }

    updatePermissions(ev) {
        $('#permissionTypes input[type="checkbox"]').prop('disabled', false).prop('checked', false);
        let currentModel = this.model.get('currentActionDetails');
        let selectedUser = currentModel.PermissionsXML.filter((user => {
            return user['@caption'] === ev.currentTarget.value;
        }))[0];
        selectedUser.Permission = selectedUser.Permission instanceof Array ? selectedUser.Permission : [selectedUser.Permission];
        selectedUser.Permission.forEach((permission) => {
            switch (permission['@type']) {
                case 'report':
                    this.checkPermission(permission['#text'], '#useAllow', "#useDeny");
                    break;
                case 'edit':
                    this.checkPermission(permission['#text'], '#editAllow', "#editDeny");
                    break;
                case 'administer':
                    this.checkPermission(permission['#text'], '#fullAllow', "#fullDeny");
                    break;
            }
        });

        $('#removePermission').attr('disabled', false);
        this.model.set('selectedPermission', ev.currentTarget.value, { silent: true });
    }

    changeActionNameAndType(event) {
        let currentModel = this.model.get('currentActionDetails');
        currentModel.ActionXML.Action[event.target.name] = event.target.value;
        if (event.target.name === '_name') {
            currentModel.Name = event.target.value;
        }
        else {
            currentModel.Type = event.target.value;
        }
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.addDefaultParameters();
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
    }

    changeActionProperty(event) {
        let currentModel = this.model.get('currentActionDetails');
        currentModel.ActionXML.Action[event.target.name] = event.target.value;
       
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.addDefaultParameters();
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
    }

    changeMethodDetails(event) {
        let currentModel = this.model.get('currentActionDetails');
        currentModel.ActionXML.Action[event.target.name] = event.target.value;
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
    }

    changeTableName(event) {
        let currentModel = this.model.get('currentActionDetails');
        currentModel.ActionXML.Action.Tables.Table['_name'] = event.target.value;
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
    }

    changeDistinguishedName(event) {
        let currentModel = this.model.get('currentActionDetails');
        currentModel.ActionXML.Action.DistinguishedName = event.target.value;
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
    }

    changeActionStatus(event) {
        let currentModel = this.model.get('currentActionDetails');
        currentModel.ActionXML.Action["_active"] = event.target.checked ? 'true' : 'false';
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
    }

    changeDistinct(event) {
        let currentModel = this.model.get('currentActionDetails');
        currentModel.ActionXML.Action.Receive["_distinctResults"] = event.target.checked ? 'true' : 'false';
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
    }

    checkPermission(permission, allowSelector, denySelector) {
        if (permission === 'allow') {
            $(allowSelector).prop('checked', true);
            $(denySelector).prop('checked', false);
        }
        else if (permission === 'deny') {
            $(allowSelector).prop('checked', false);
            $(denySelector).prop('checked', true);
        }
    }

    convertToXMLAndCompress(connectionObject) {
        const XMLObject = xjService.toXML(connectionObject);
        console.log("XML Object", XMLObject);
        return zLib.compressForm(XMLObject);
    }

    cleanUnusedParametersFromAction() {
        let currentModel = this.model.get('currentActionDetails');
        const updateActions = Immutable.Set([constants.CONNECTION_GOOGLE_UPDATE,
        constants.CONNECTION_DATABASE_UPDATE,
        constants.CONNECTION_DIRECTORY_SERVICES_UPDATE,
        constants.CONNECTION_TEXT_UPDATE,
        constants.CONNECTION_FORMS_UPDATE]);
        const isUpdate = updateActions.contains(currentModel.Type);

        const insertActions = Immutable.Set([constants.CONNECTION_DATABASE_INSERT,
        constants.CONNECTION_DIRECTORY_SERVICES_INSERT,
        constants.CONNECTION_FORMS_INSERT,
        constants.CONNECTION_GOOGLE_INSERT,
        constants.CONNECTION_TEXT_INSERT]);
        const isInsert = insertActions.contains(currentModel.Type);

        const deleteActions = Immutable.Set([constants.CONNECTION_DATABASE_DELETE,
        constants.CONNECTION_DIRECTORY_SERVICES_DELETE,
        constants.CONNECTION_FORMS_DELETE,
        constants.CONNECTION_GOOGLE_DELETE,
        constants.CONNECTION_TEXT_DELETE]);
        const isDelete = deleteActions.contains(currentModel.Type);

        const webServiceActions = Immutable.Set([constants.CONNECTION_WEB_SERVICES_STRING_RESULT,
        constants.CONNECTION_WEB_SERVICES_XML_RESULT]);
        const isWebService = webServiceActions.contains(currentModel.Type);

        const restServiceActions = Immutable.Set([constants.CONNECTION_REST_GET,
            constants.CONNECTION_REST_POST,constants.CONNECTION_REST_PUT, constants.CONNECTION_REST_DELETE]);
            const isRestService = restServiceActions.contains(currentModel.Type) || currentModel.Type === "raw" || currentModel.Type === "binary";

        const storedProcedureActions = Immutable.Set([constants.CONNECTION_DATABASE_STORE_PROCEDURE]);
        const isStoredProcedure = storedProcedureActions.contains(currentModel.Type);

        // PF-3074 Google Insert is an special case that needs the values to be -1 as the parameters that will be sent doesnt have an operation
        if (isUpdate || isInsert || isDelete) { //Remove receive parameters for Update, Insert and Delete type of actions
            currentModel.ActionXML.Action.Receive.Parameter = [];
        }

        if (!isUpdate && !isInsert && !isWebService && !isRestService && !isStoredProcedure) { //If is not and update/insert action or is not a web service action then only the parameters with operation != -1 should be included
            let validConditionalSendParams = [];
            if (currentModel.ActionXML.Action.Send.Parameter instanceof Array) {
                validConditionalSendParams = currentModel.ActionXML.Action.Send.Parameter.filter(item => item._operation !== '-1');
            } else {
                if (currentModel.ActionXML.Action.Send.Parameter && currentModel.ActionXML.Action.Send.Parameter._operation !== '-1') {
                    validConditionalSendParams = [currentModel.ActionXML.Action.Send.Parameter];
                }
            }

            currentModel.ActionXML.Action.Send.Parameter = validConditionalSendParams;
        }

        this.model.set('currentActionDetails', currentModel, { silent: true });
    }

    applyChanges() {
        this.cleanUnusedParametersFromAction();
        let currentModel = this.model.get('currentActionDetails');

        currentModel.ActionXML.Action.Send.Parameter.forEach((element) => {
            element['_isNew'] = false;
        })
        currentModel.ActionXML.Action.Receive.Parameter.forEach((element) => {
            element['_isNew'] = false;
        });

         //Always set the XML action ID to the model action ID to avoid issues with export/import
        currentModel.ActionXML.Action._id = this.model.get('actionId');
        
        let updateParameters = {
            connectionId: this.model.get('connectionId'),
            actionId: this.model.get('actionId'),
            name: currentModel.ActionXML.Action['_name'],
            type: currentModel.ActionXML.Action['_type'],
            isActive: currentModel.ActionXML.Action['_active'],
            actionXML: this.convertToXMLAndCompress(currentModel.ActionXML),
            permissionsXML: this.formatPermissionsForResponse(currentModel.PermissionsXML)
        };

        const originalModel = this.model.get('actionDetails');
        const originalParamenters = {
            connectionId: this.model.get('connectionId'),
            actionId: this.model.get('actionId'),
            name: originalModel.ActionXML.Action['_name'],
            type: originalModel.ActionXML.Action['_type'],
            isActive: originalModel.ActionXML.Action['_active'],
            actionXML: this.convertToXMLAndCompress(originalModel.ActionXML),
            permissionsXML: this.formatPermissionsForResponse(originalModel.PermissionsXML)
        };

        undoService.add({
            undo: () => {
                this.persistData(originalParamenters);
            },
            redo: () => {
                this.persistData(updateParameters);
            }
        }, textConstants.UNDO_UPDATE_CONNECTION);

        this.persistData(updateParameters);
        util.setUndoRedoAccess();


    }

    persistData(updateParameters) {
        // // Saving Changes made on the form.
        RestService.updateAction(updateParameters).then((data) => {
            console.log('updated Action');
            console.log(data);
            eventBus.trigger(constants.EV_UPDATE_ACTION_DETAILS, this.model.get('actionId'), this.model.get('connectionId'), updateParameters.type);
        }).catch((err) => {
            console.log('Error on update');
            console.log('This is the error', err);
        })

    }

    cancelChanges() {
        console.log('Canceling Changes');
        this.model.set('currentActionDetails', $.extend(true, {}, this.model.get('actionDetails')), { silent: true });
        this.model.unset('selectedPermission', { silent: true });
        this.model.set('hasChanges', false, { silent: true });
        this.model.trigger('change');
    }


    formatPermissionsForResponse(permissions) {
        let permissionList = permissions;
        if (permissions) {
            let permissionsOpeningTag = '<Permissions>';
            let permissionsClosingTag = '</Permissions>';
            permissionList = permissions.reduce((accum, elem) => {
                let defaultId = '>';
                if (!(elem['@type'] === 'world' || elem['@type'] === 'everyone')) {
                    defaultId = ` id="${elem['@id']}">`;
                }
                let userXML = accum + `<User type="${elem['@type']}"` + defaultId;
                let permissions = elem.Permission instanceof Array ? elem.Permission : [elem.Permission];
                permissions.forEach(permission => {
                    userXML = userXML +
                        `<Permission type="${permission ? permission['@type'] : "view"}">` +
                        `${permission ? permission['#text'] : "allow"}` +
                        `</Permission>`
                });
                userXML = userXML + `</User>`;
                return userXML;
            }, '');
            permissionList = permissionsOpeningTag + permissionList + permissionsClosingTag;
            console.log('CurrentSendPermissionsBeforeReplacing', permissionList);
            permissionList = permissionList.replace(/</g, '&lt;').replace(/>/g, '&gt;');
            console.log('CurrentSendPermissions', permissionList);
        }
        return permissionList;
    }

    addPermission(ev) {
        ev.preventDefault();

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            RestService.browseAllUsers().then((usersData) => {
                let users = [];
                let userAccum = [];
                userAccum.push(this.createUserSpecialItem('Everyone', constants.CONNECTION_ACTION_EVERYONE_PERMISSION_ID.toString()));

                if (usersData.AllUsers.User) {
                    users = _.union(userAccum, util.enforceArrayType(usersData.AllUsers.User));
                }

                let items = users.map((item) => {
                    return {
                        label: item['@caption'],
                        listType: item['@type'],
                        items: item
                    }
                });

                let self = this;
                let permissionView = new SelectItemModalView({ model: new Model({ items: items }), spinner: spinner });
                permissionView.render().then(selectedItem => {
                    let modelUpdated = false;
                    if (selectedItem) {
                        let currentModel = this.model.get('currentActionDetails');
                        let currentPermissionList;

                        if (currentModel.PermissionsXML) {
                            // Checking if the permission selected is not already present in the current list.
                            currentPermissionList = currentModel.PermissionsXML;

                            let permissionsChanged = currentPermissionList.filter((permission) => {
                                return permission['@id'] === selectedItem.items['@id'];
                            });


                            if (permissionsChanged.length === 0) {
                                selectedItem.items.Permission = [];
                                currentPermissionList.push(selectedItem.items);
                                currentModel.PermissionsXML = currentPermissionList;
                                modelUpdated = true;
                            }
                        }
                        else {
                            currentPermissionList = [];
                            selectedItem.items.Permission = [];
                            currentPermissionList.push(selectedItem.items);
                            currentModel.PermissionsXML = currentPermissionList;
                            modelUpdated = true;
                        }

                        if (modelUpdated) {
                            self.model.set('currentActionDetails', currentModel, { silent: true });
                            self.model.set('hasChanges', true, { silent: true });
                            this.model.trigger('change');
                            $(`select[name='permissions']`).val(selectedItem.label).change();
                        }
                    }
                }).catch((errMsg) => {
                    console.log(errMsg);
                    notificationService.error(errMsg);
                });
            });
        }, 10);
    }

    createUserSpecialItem(name, id) {
        return { '@type': `${name.toLowerCase()}`, '@id': id ? id : '-2147483524', '@caption': `${name}` };
    }

    removePermission(ev) {
        ev.preventDefault();
        let selectedPermission = $(`select[name='permissions']`).val();
        let currentModel = this.model.get('currentActionDetails');

        // Checking if the permission selected is not already present in the current list.
        let currentPermissionList = currentModel.PermissionsXML;
        let currentPermissionListWithRemovedElement = currentPermissionList.filter((permission) => {
            return permission['@caption'] !== selectedPermission;
        });
        if (currentPermissionListWithRemovedElement.length < currentPermissionList.length) {
            currentModel.PermissionsXML = currentPermissionListWithRemovedElement;
            this.model.set('currentActionDetails', currentModel, { silent: true });
            this.model.set('hasChanges', true, { silent: true });
            this.model.unset('selectedPermission', { silent: true });
            this.model.trigger('change');
        }
    }

    deleteAction(ev) {
        let actionItemSelected = listService.actionItemSelected;
        let simpleModal = util.createDialogDeleteConfirmation("Delete Connection", `Are you sure you want to delete the action ${actionItemSelected.name}?`);

        simpleModal.render().then((result) => {
            if (result === 'Ok') {
                ActionService.makeDeleteAction(actionItemSelected.actionId, actionItemSelected.connectionId, actionItemSelected.type);
                listService.actionItemSelected = undefined;
            }
        }).catch((err) => {
            console.log('Error Showing Action List Confirmation Message', err);
            notificationService.error('Error Showing Action List Confirmation Message' + err.MESSAGE);
        });
    }

    static makeDeleteAction(actionId, connectionId, actionType, addUndoServicee = true) {
        return RestService.deleteAction(actionId, connectionId).then(response => {
            console.log("Action Delete", response);

            eventBus.trigger(constants.EV_DELETE_ACTION, connectionId, actionType);

            if (addUndoServicee) {
                undoService.add({
                    undo: () => {
                        ConnectionDashboardController.undeleteAction(connectionId, actionId, actionType, listService.dashboardLayout.leftPanelView)
                            .then(data => { });
                    },
                    redo: () => {
                        ConnectionDashboardController.redoDeleteAction(actionId, connectionId, actionType)
                    }
                }, textConstants.UNDO_DELETE_ACTION);

                util.setUndoRedoAccess();
            }

            return response;
        }).catch(err => {
            console.log('Error Deleting Action', err);
            notificationService.error('Error Deleting Action' + err.MESSAGE);
        });
    }

    autoComplete(ev) {
        return new Promise((resolve, reject) => {
            RestService.getConnectionDetails(this.model.get('connectionId')).then((connectionDetails) => {
                const connectionXML = FormLoadService._decompressForm(connectionDetails.ConnectionXML['#cdata-section']);
                console.log("Uncompressed XML", connectionXML);

                const connectionObject = xjService.toJSON(connectionXML).Connection;
                console.log('Connection Object', connectionObject);

                let tableName = '';
                // Database type
                if (connectionObject._type === '1') {
                    tableName = this.model.get('currentActionDetails').ActionXML.Action.Tables.Table._name;
                }

                if (connectionObject._type === constants.GOOGLE_GROUP_TYPE ||
                    connectionObject._type === constants.GOOGLE_ACTION_DETAIL_VIEW) {
                    this.makeAutoCompletionGoogle(connectionObject, ev)
                        .then(resolve)
                        .catch(reject);
                } else {
                    this.makeAutoCompletion(connectionObject, tableName, connectionObject._type)
                        .then(resolve)
                        .catch(reject);
                }
            }).catch((err => {
                console.log('Error Retrieving Connection Details Data ' + err);
                notificationService.error('Error Retrieving Connection Details Data' + (err.MESSAGE || err || ''));
                reject();
            }));
        });
    }

    makeAutoCompletion(connectionObject, tableName, type) {
        return new Promise((resolve, reject) => {
            RestService.getAutoCompleteData(connectionObject, tableName, type).then((result) => {
                console.log("AutoCompletion Result", result);
                if (this.checkDatabaseResponseForErrors(result)) {
                    resolve(xjService.toJSON(result.RESULT.RESPONSE['#cdata-section']));
                }
                else {
                    reject();
                }
            }).catch((err) => {
                console.log('Error on Making the Web Service Call', err);
                notificationService.error('Agent communication error ' + err.MESSAGE['#cdata-section'] || err.MESSAGE || err);
                reject();
            });
        });
    }

    checkDatabaseResponseForErrors(response) {
        // Null response, or error code means we have an error
        if (!response || !response.RESULT || response.RESULT.ERROR.CODE !== '0') {
            return false;
        }

        let responseBody = xjService.toJSON(response.RESULT.RESPONSE['#cdata-section']);

        // Error received from Connection Agent or Service called        
        if (responseBody.response.error && responseBody.response.error.$) {
            notificationService.error(responseBody.response.error._message);
            return false;
        }

        return true;
    }

    setSelectedRow(newIndex, tableId){
        const rows = $(tableId).jqGrid('getDataIDs');
        $(tableId).jqGrid('setSelection', rows[newIndex]);
    }

    //When Items are moved up or dowm, the update method is trated specially due to all parameters are saved in just one array (send)
    //We need to separate them into two arrays just like if they were another method and then reorganize them
    //for last we need to merge them into the original array.
    itemUp(ev) {
        const updateActions = Immutable.Set([constants.CONNECTION_GOOGLE_UPDATE,
        constants.CONNECTION_DATABASE_UPDATE,
        constants.CONNECTION_DIRECTORY_SERVICES_UPDATE,
        constants.CONNECTION_TEXT_UPDATE,
        constants.CONNECTION_FORMS_UPDATE]);

        let isSend = ev.currentTarget.name.indexOf('Send') >= 0,
            myGrid = '#' + $(ev.currentTarget).attr('data-table-type'),
            selRowId = parseInt($(myGrid).jqGrid('getGridParam', 'selrow')),
            currentModel = this.model.get('currentActionDetails');

        const isUpdate = updateActions.contains(currentModel.Type);
        let currentModelItems = [];
        let auxModeelItems = [];

        if (isUpdate) {
            if (isSend) {
                currentModelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation !== '-1');
                auxModeelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation === '-1');
            } else {
                currentModelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation === '-1');
                auxModeelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation !== '-1');
            }
        } else {
            currentModelItems = isSend ? currentModel.ActionXML.Action.Send.Parameter : currentModel.ActionXML.Action.Receive.Parameter;
        }

        if (selRowId > 0) {
            currentModelItems[selRowId] = currentModelItems.splice((selRowId - 1), 1, currentModelItems[selRowId])[0];
            if (isUpdate) {
                if (isSend) {
                    currentModel.ActionXML.Action.Send.Parameter = currentModelItems.concat(auxModeelItems);
                } else {
                    currentModel.ActionXML.Action.Send.Parameter = auxModeelItems.concat(currentModelItems);
                }
            } else {
                if (isSend) {
                    currentModel.ActionXML.Action.Send.Parameter = currentModelItems;
                }
                else {
                    currentModel.ActionXML.Action.Receive.Parameter = currentModelItems;
                }
            }
            this.model.set('currentListDetails', currentModel, { silent: true });
            this.model.set('hasChanges', true, { silent: true });
            this.model.trigger('change');
            const newIndex = selRowId - 1;
            this.setSelectedRow(newIndex, myGrid)
            console.log("Model After Save Cell", currentModel);
        }
    }


    itemDown(ev) {
        const updateActions = Immutable.Set([constants.CONNECTION_GOOGLE_UPDATE,
        constants.CONNECTION_DATABASE_UPDATE,
        constants.CONNECTION_DIRECTORY_SERVICES_UPDATE,
        constants.CONNECTION_TEXT_UPDATE,
        constants.CONNECTION_FORMS_UPDATE]);

        let isSend = ev.currentTarget.name.indexOf('Send') >= 0,
            myGrid = '#' + $(ev.currentTarget).attr('data-table-type'),
            selRowId = parseInt($(myGrid).jqGrid('getGridParam', 'selrow')),
            currentModel = this.model.get('currentActionDetails');

        const isUpdate = updateActions.contains(currentModel.Type);
        let currentModelItems = [];
        let auxModeelItems = [];
        if (isUpdate) {
            if (isSend) {
                currentModelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation !== '-1');
                auxModeelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation === '-1');
            } else {
                currentModelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation === '-1');
                auxModeelItems = currentModel.ActionXML.Action.Send.Parameter.filter(p => p._operation !== '-1');
            }
        } else {
            currentModelItems = isSend ? currentModel.ActionXML.Action.Send.Parameter : currentModel.ActionXML.Action.Receive.Parameter;
        }

        if (selRowId < (currentModelItems.length - 1)) {
            currentModelItems = [...currentModelItems.slice(0, selRowId), currentModelItems[selRowId + 1], currentModelItems[selRowId], ...currentModelItems.slice(selRowId + 2)];
            if (isUpdate) {
                if (isSend) {
                    currentModel.ActionXML.Action.Send.Parameter = currentModelItems.concat(auxModeelItems);
                } else {
                    currentModel.ActionXML.Action.Send.Parameter = auxModeelItems.concat(currentModelItems);
                }
            } else {
                if (isSend) {
                    currentModel.ActionXML.Action.Send.Parameter = currentModelItems;
                }
                else {
                    currentModel.ActionXML.Action.Receive.Parameter = currentModelItems;
                }
            }
            this.model.set('currentActionDetails', currentModel, { silent: true });
            this.model.set('hasChanges', true, { silent: true });
            this.model.trigger('change');
            const newIndex = selRowId + 1;
            this.setSelectedRow(newIndex, myGrid)
            console.log("Model After Save Cell", currentModel);
        }
    }

    itemNew(ev) {
        const currentModel = this.model.get('currentActionDetails');
        const updateActions = Immutable.Set([constants.CONNECTION_GOOGLE_UPDATE,
        constants.CONNECTION_DATABASE_UPDATE,
        constants.CONNECTION_DIRECTORY_SERVICES_UPDATE,
        constants.CONNECTION_TEXT_UPDATE,
        constants.CONNECTION_FORMS_UPDATE]);
        const isUpdate = updateActions.contains(currentModel.Type);

        const insertActions = Immutable.Set([constants.CONNECTION_DATABASE_INSERT,
        constants.CONNECTION_DIRECTORY_SERVICES_INSERT,
        constants.CONNECTION_FORMS_INSERT,
        constants.CONNECTION_GOOGLE_INSERT,
        constants.CONNECTION_TEXT_INSERT]);
        const isInsert = insertActions.contains(currentModel.Type);

        const deleteActions = Immutable.Set([constants.CONNECTION_DATABASE_DELETE,
        constants.CONNECTION_DIRECTORY_SERVICES_DELETE,
        constants.CONNECTION_FORMS_DELETE,
        constants.CONNECTION_GOOGLE_DELETE,
        constants.CONNECTION_TEXT_DELETE]);
        const isDelete = deleteActions.contains(currentModel.Type);

        const webServiceActions = Immutable.Set([constants.CONNECTION_WEB_SERVICES_STRING_RESULT,
        constants.CONNECTION_WEB_SERVICES_XML_RESULT]);
        const isWebService = webServiceActions.contains(currentModel.Type);
        const isFormUpdate = currentModel.Type === constants.CONNECTION_FORMS_UPDATE;

        const restServiceActions = Immutable.Set([constants.CONNECTION_REST_GET,
            constants.CONNECTION_REST_POST,constants.CONNECTION_REST_PUT, constants.CONNECTION_REST_DELETE]);
            const isRestService = restServiceActions.contains(currentModel.Type);
          
        const storedProcedureActions = Immutable.Set([constants.CONNECTION_DATABASE_STORE_PROCEDURE]);
        const isStoredProcedure = storedProcedureActions.contains(currentModel.Type);

        const isSend = ev.currentTarget.name.indexOf('Send') >= 0,
            myGrid = '#' + $(ev.currentTarget).attr('data-table-type');

        let currentModelItems;

        if (isSend || isUpdate) {
            currentModelItems = currentModel.ActionXML.Action.Send.Parameter;
        } else {
            currentModelItems = currentModel.ActionXML.Action.Receive.Parameter;
        }

        if (this.model.get('currentActionDetails').Type.charAt(0) === constants.GOOGLE_GROUP_TYPE_DETAIL_VIEW &&
            ev.currentTarget.name.indexOf('Send') >= 0) {
            let sendParameters = currentModelItems;
            if (currentModel.Type !== constants.CONNECTION_GOOGLE_INSERT) {
                sendParameters = currentModelItems.filter(item => item._operation !== '-1');
            }

            if (sendParameters.length >= 5) {
                const confirmView = new AlertDialogView({
                    model: new Model({
                        text: 'You reached the maximum number of parameters',
                        title: 'Parameters',
                        height: 200
                    })
                });
                confirmView.render();
                return;
            }
        }

        let index = $(myGrid).jqGrid('getGridParam', 'records');
        let _name;
        let invalidName = true;
        let currentModelItemsCounter = 0;
        let currentModelLength = currentModelItems.length;

        if (isUpdate) {
            index = 0;
            if (isSend) {
                currentModelLength = currentModelItems.filter(item => item._operation !== '-1').length;
            } else {
                currentModelLength = currentModelItems.filter(item => item._operation === '-1').length;
            }
        }

        while (invalidName && currentModelItemsCounter <= currentModelLength) {
            currentModelItemsCounter++;
            _name = isSend || isUpdate ? 'Parameter ' + (index + 1) : 'Return Parameter ' + (index + 1);
            const sendParameters = currentModelItems.filter(item => item._name === _name);
            if (!sendParameters || sendParameters.length === 0) {
                invalidName = false;
            } else {
                index++;
            }
        }

        let op = ev.currentTarget.name.indexOf('Send') >= 0 ? '0' : '-1';
        if (isInsert || isWebService || isRestService || (!isSend && isUpdate) || (isSend && isStoredProcedure) || (isSend && isFormUpdate)) { //For this kind of actions the operator is always -1
            op = '-1';
        }
        const newRow = {
            '_fixedValue': '',
            '_id': sequenceService.nextDomId(),
            '_isFixed': 'false',
            '_name': _name,
            '_operation': op,
            '_value': '',
            '_isNew': true
        };

        if(isRestService && isSend){
            if (["110", "113"].includes(currentModel.ActionXML.Action._type)){
                newRow._placement = "querystring";
            }else{
                newRow._placement = "body";
                newRow._dataType = 'System.String';
            }
            
            newRow._value = _name
            newRow._path = '{' + _name + '}';
            newRow._isNullable = 'false';
        }
        //$(myGrid).addRowData((index + 1), newRow);

        if (op !== '-1') {
            let lastIndex = _.findLastIndex(currentModelItems, (item) => {
                return parseInt(item['_operation']) > -1;
            });
            currentModelItems = [...currentModelItems.slice(0, lastIndex + 1), newRow, ...currentModelItems.slice(lastIndex + 1)];
        }
        else {
            currentModelItems.push(newRow);
        }

        if (isSend || isUpdate) {
            currentModel.ActionXML.Action.Send.Parameter = currentModelItems;
        }
        else {
            currentModel.ActionXML.Action.Receive.Parameter = currentModelItems;
        }

        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
        console.log("Model After Save Cell", this.model.get('currentActionDetails'));
    }

    itemRemove(ev) {
        const updateActions = Immutable.Set([constants.CONNECTION_GOOGLE_UPDATE, constants.CONNECTION_DATABASE_UPDATE, constants.CONNECTION_DIRECTORY_SERVICES_UPDATE, constants.CONNECTION_TEXT_UPDATE]);
        let isSend = ev.currentTarget.name.indexOf('Send') > 0,
            isUpdate = updateActions.contains(this.model.get('currentActionDetails').Type),
            myGrid = '#' + $(ev.currentTarget).attr('data-table-type'),
            selRowId = parseInt($(myGrid).jqGrid('getGridParam', 'selrow')),
            currentModel = this.model.get('currentActionDetails'),
            currentModelItems = isSend || isUpdate ? currentModel.ActionXML.Action.Send.Parameter : currentModel.ActionXML.Action.Receive.Parameter;

        if (isUpdate) {
            let returns = currentModelItems.filter(i => i._operation === '-1');
            let sends = currentModelItems.filter(i => i._operation !== '-1');
            let itemsTemp = [];
            if (isSend) {
                itemsTemp = [...sends.slice(0, selRowId), ...sends.slice(selRowId + 1)];
                currentModelItems = [...itemsTemp, ...returns];
            } else {
                itemsTemp = [...returns.slice(0, selRowId), ...returns.slice(selRowId + 1)];
                currentModelItems = [...sends, ...itemsTemp];
            }
        } else {
            currentModelItems = [...currentModelItems.slice(0, selRowId), ...currentModelItems.slice(selRowId + 1)];
        }

        if (isSend || isUpdate) {
            currentModel.ActionXML.Action.Send.Parameter = currentModelItems;
        }
        else {
            currentModel.ActionXML.Action.Receive.Parameter = currentModelItems;
        }
        this.model.set('currentActionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true, { silent: true });
        this.model.trigger('change');
        let previousRowId = selRowId <= 0 ? 0 : selRowId - 1;
        if (currentModelItems.length > 0) {
            $(myGrid).jqGrid('setSelection', previousRowId);
        }
        console.log("Model After Save Cell", currentModel);
    }

    testAction() {
        let currentModel = this.model.get('currentActionDetails');
        let actionId = this.model.get('actionId');
        const connectionId = this.model.get("connectionId");
        if (!currentModel.ActionXML.Action._id || currentModel.ActionXML.Action._id !== actionId) {
            currentModel.ActionXML.Action._id = actionId;
        }
        if (!currentModel.ActionXML.Action._connectionId || currentModel.ActionXML.Action._connectionId !== connectionId) {
            currentModel.ActionXML.Action._connectionId = connectionId;
        }

        let testValues = currentModel.ActionXML.Action.Send.Parameter.map(action => "");
        let testActionModal = new TestActionModalView({ model: new Model({ currentActionDetails: currentModel, testValues: testValues, actionId: actionId }) });
        testActionModal.render().then((result) => {
            console.log("This is the result", result);
        })
    }

    makeAutoCompletionGoogle(connectionObject, ev) {
        return new Promise((resolve, reject) => {
            let param = {};
            param.refresh_token = connectionObject._refreshCode;
            param.access_token = connectionObject._accessCode;
            param.fileId = connectionObject._fileId;
            param.sheetName = connectionObject._spreadsheet;

            RestService.googleSheetColumnsOAuth2(param).then((result) => {
                console.log("AutoCompletion Result", result);
                if (result.Columns.Column) {
                    resolve(result.Columns.Column);
                }
                else {
                    reject();
                }
            }).catch((err) => {
                console.log('Error Getting Columns GoogleSpreadSheet', err);
                notificationService.error('Communication error ' + (err.MESSAGE['#cdata-section'] || err.MESSAGE || err));
                reject();
            });
        });
    }

    addDefaultParameters() {
        let currentModel = this.model.get('currentActionDetails');
        let response = currentModel.ActionXML.Action._responseType;

        // Vector DB action types have fixed parameters
        const vectorDbTypes = [
            constants.CONNECTION_VECTORDB_QUERY,
            constants.CONNECTION_VECTORDB_UPSERT,
            constants.CONNECTION_VECTORDB_DELETE
        ];
        if (vectorDbTypes.includes(currentModel.Type)) {
            this._applyVectorDBDefaults(currentModel);
            this.model.set('currentActionDetails', currentModel, { silent: true });
            return;
        }

        if (currentModel.Type === constants.CONNECTION_WEB_SERVICES_STRING_RESULT || (response === "raw" || response === "binary")) {
            let param;
            if (Array.isArray(currentModel.ActionXML.Action.Receive.Parameter)) {
                if (currentModel.ActionXML.Action.Receive.Parameter.length === 1) {
                    param = currentModel.ActionXML.Action.Receive.Parameter[0];
                }
            } else {
                param = currentModel.ActionXML.Action.Receive.Parameter;
            }

            if (!param || (param && (param._name !== 'Result' || param._value !== 'Result' || param._operation !== 0))) {

                if(response === "binary"){

                    currentModel.ActionXML.Action.Receive.Parameter = 
                    [{
                        '_id': sequenceService.nextDomId(),
                        '_name': 'File Name',
                        '_operation': 0,
                        '_value': 'fileName',
                        '_isFixed': 'false',
                        '_fixedValue': ''
                    },{
                        '_id': sequenceService.nextDomId(),
                        '_name': 'Base 64',
                        '_operation': 0,
                        '_value': 'base64',
                        '_isFixed': 'false',
                        '_fixedValue': ''
                    }];
                    
                }
                else{
                    currentModel.ActionXML.Action.Receive.Parameter = 
                    [{
                        '_id': sequenceService.nextDomId(),
                        '_name': 'Result',
                        '_operation': 0,
                        '_value': 'Result',
                        '_isFixed': 'false',
                        '_fixedValue': ''
                    }];
                }
            }

            this.model.set('currentActionDetails', currentModel, { silent: true });
        }
    }

    _applyVectorDBDefaults(currentModel) {
        const connectionId = currentModel.ActionXML.Action._connectionId || '';
        const mkParam = (name, isFixed = 'false', fixedValue = '') => ({
            _id: sequenceService.nextDomId(),
            _name: name,
            _operation: '0',
            _value: name,
            _isFixed: isFixed,
            _fixedValue: fixedValue
        });

        switch (currentModel.Type) {
            case constants.CONNECTION_VECTORDB_QUERY:
                currentModel.ActionXML.Action.Send = {
                    Parameter: [
                        mkParam('userMessage'),
                        mkParam('vectorDbConnectionId', 'true', connectionId)
                    ]
                };
                currentModel.ActionXML.Action.Receive = {
                    Parameter: [
                        mkParam('message'),
                        mkParam('supportText'),
                        mkParam('txtPaths')
                    ]
                };
                break;

            case constants.CONNECTION_VECTORDB_UPSERT:
                // instanceId is auto/fixed; user adds field params from linked app
                currentModel.ActionXML.Action.Send = {
                    Parameter: [
                        mkParam('instanceId')
                    ]
                };
                currentModel.ActionXML.Action.Receive = {
                    Parameter: [
                        mkParam('success'),
                        mkParam('vectorId'),
                        mkParam('message')
                    ]
                };
                break;

            case constants.CONNECTION_VECTORDB_DELETE:
                currentModel.ActionXML.Action.Send = {
                    Parameter: [
                        mkParam('instanceId')
                    ]
                };
                currentModel.ActionXML.Action.Receive = {
                    Parameter: [
                        mkParam('success'),
                        mkParam('message')
                    ]
                };
                break;
        }
    }

}

export default ActionService;

